import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancelExport: 'Cancel the export',
    inputEmailLabel: 'E-mail',
    inputNameLabel: 'Name',
    nextReportDate: 'Next export **{date}**',
    title: 'Your monthly export',
  },
  fr: {
    cancelExport: 'Supprimer l’export',
    inputEmailLabel: 'E-mail',
    inputNameLabel: 'Nom',
    nextReportDate: 'Prochain envoi **{date}**',
    title: 'Votre export mensuel',
  },
} as const);

export default locales;
